/**
 * BuildScenarioTunersStyles - Styled components for the tuning settings component.
 *
 * ARCHITECTURE:
 * - Provides layout components for HStack and VStack patterns.
 * - Includes styling for titles, sliders, and input fields.
 * - Integrates with the existing theme system.
 */

import styled from '@emotion/styled'
import { InfoMedium600Style } from '../../../../../../styles/Text.styles'
import theme from '../../../../../../styles/theme'

// Main horizontal container
export const MainHStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: flex-start;
  width: 80%;
  padding: 1rem;
`

// Vertical container for each tuning section
export const TuningVStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
`

// Settings title component
export const SettingsTitle = styled.h3`
  ${InfoMedium600Style};
  color: ${theme.colors.standardText};
  margin: 0;
  margin-bottom: 0.5rem;
  transition: color 0.2s ease;

  ${(props) =>
    props.disabled &&
    `
        color: ${theme.colors.veryVeryVeryFadedText};
        opacity: 0.6;
    `}
`

// Horizontal container for slider and input
export const SliderInputHStack = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  align-items: center;
`

// Grid cell styling for consistent row height and alignment
export const GridCellContainer = styled.div`
  height: 5rem;
  display: flex;
  align-items: center;
`
